import { uuid } from '@/util';

import { useVBasePopoverContext } from '../VBasePopover/hook';
import { VFlex } from '../VFlex';
import { VStack } from '../VStack';
import { VTab, VTabContent, VTabTrigger, VTabTriggerContainer } from '../VTab';
import { Close } from '../asset';
import { VNotificastionList } from './VNotificastionList';
import { VNotificationEmpty } from './VNotificationEmpty';
import { useVNotification } from './hook';

const TAB_VALUE_FOR_EMPTY = uuid();

export const VNotificationContent = () => {
  const {
    tabList,
    isEmptyGroupList,
    tabValue,
    onTabChange,
    scrollContainerRef,
    isNoTabList,
    renderTitleRight: renderRightButton,
    title,
  } = useVNotification();

  const { hide } = useVBasePopoverContext();

  return (
    <VTab
      defaultValue={
        isNoTabList
          ? TAB_VALUE_FOR_EMPTY
          : (tabList?.[0]?.value ?? TAB_VALUE_FOR_EMPTY)
      }
      size="small"
      value={tabValue}
      onValueChange={onTabChange}
    >
      <VStack
        gap={0.5}
        className="flex max-h-[calc(100vh-300px)] w-[424px]! flex-col py-2"
      >
        <VFlex
          className="w-full shrink-0 px-4 py-1"
          items="center"
          justify="between"
        >
          <div className="text-headline-sm font-semibold">
            {title ?? 'Notifications'}
          </div>

          <VFlex gap={0.25} items="center">
            {renderRightButton?.()}
            <Close
              className="h-6 w-6 text-gray-400"
              role="button"
              onClick={hide}
            />
          </VFlex>
        </VFlex>

        {isNoTabList ? null : (
          <VFlex
            className="w-full shrink-0 px-4"
            items="center"
            justify="between"
          >
            <VTabTriggerContainer>
              {tabList?.map(tab => (
                <VTabTrigger
                  key={tab.value}
                  value={tab.value}
                  disabled={tab.disabled}
                >
                  {tab.label}
                </VTabTrigger>
              ))}
            </VTabTriggerContainer>
          </VFlex>
        )}

        <div
          ref={scrollContainerRef}
          className="min-h-0 flex-1 overflow-y-auto"
        >
          <VTabContent value={tabValue ?? TAB_VALUE_FOR_EMPTY}>
            {isEmptyGroupList ? <VNotificationEmpty /> : <VNotificastionList />}
          </VTabContent>
        </div>
      </VStack>
    </VTab>
  );
};
